import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BestEarplugLawyersWrapper from "@components/layouts/bestearpluglawyersWrapper";

export default function BestEarplugLawyersHome(): ReactElement {
    return (
        <BestEarplugLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Military Earplugs"
                    domain="BestEarplugLawyers.com"
                />
            </div>
        </BestEarplugLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
